import { cn } from "@/lib/cn";

/** Mini illustration: a browser frame with the gem mark. Decorative. */
export function BrandShapes({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 200 120" className={cn("text-primary", className)} aria-hidden="true" focusable="false">
      <defs>
        <linearGradient id="bs-g" x1="0" x2="1" y1="0" y2="1">
          <stop offset="0" stopColor="#E8EBFF" />
          <stop offset="1" stopColor="#F4F6FF" />
        </linearGradient>
      </defs>
      <rect x="30" y="14" width="140" height="92" rx="14" fill="url(#bs-g)" stroke="#D5DAFF" />
      <rect x="30" y="14" width="140" height="18" rx="14" fill="#fff" stroke="#D5DAFF" />
      <circle cx="44" cy="23" r="3" fill="#C8CCF9" />
      <circle cx="54" cy="23" r="3" fill="#D5DAFF" />
      <circle cx="64" cy="23" r="3" fill="#E8EBFF" />
      <rect x="44" y="44" width="62" height="8" rx="4" fill="#5C67D4" opacity=".85" />
      <rect x="44" y="58" width="44" height="6" rx="3" fill="#9AA3F2" />
      <rect x="44" y="76" width="34" height="14" rx="7" fill="#5C67D4" />
      <g transform="translate(148 48) scale(.42)">
        <path fill="#7985EB" d="M32 4L56.25 18L56.25 46L32 60L7.75 46L7.75 18Z" />
        <path fill="#C8CCF9" d="M32 4L7.75 18L7.75 32Z" />
        <path fill="#141B73" d="M48.16 32L56.25 32L56.25 46Z" />
        <g fill="none" stroke="#fff" strokeWidth="2.4" strokeLinejoin="round">
          <path d="M32 4L56.25 46L7.75 46Z" />
          <path d="M32 60L56.25 18L7.75 18Z" />
          <path d="M7.75 32H56.25" />
        </g>
      </g>
      <path d="M16 96l8-4 4 8" fill="none" stroke="#9AA3F2" strokeWidth="2.5" strokeLinecap="round" />
      <circle cx="184" cy="30" r="5" fill="#06B6D4" opacity=".5" />
      <rect x="176" y="84" width="10" height="10" rx="3" fill="#5C67D4" opacity=".25" transform="rotate(18 181 89)" />
    </svg>
  );
}
